//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import userChecks from '~/mixins/userChecks';
export default {
    mixins: [userChecks],
    async fetch() {
        await Promise.all([ 
            this.$store.dispatch('pagesStore/getPage', 'modellen'),
            this.$store.dispatch('bannerStore/getBanner', 'collection'),
            this.$store.dispatch('resourcesStore/getResources', this.queries.models)
        ])
    },
    head() {
        return {
            title: this.pages.modellen && this.pages.modellen.seo ? this.pages.modellen.seo.title : 'Modellen | Meiden van Holland',
            meta: [
                { hid: 'title', name: 'title', content: this.pages.modellen && this.pages.modellen.seo ? this.pages.modellen.seo.title : 'Modellen | Meiden van Holland' },
                { hid: 'og:title', name: 'og:title', content: this.pages.modellen && this.pages.modellen.seo ? this.pages.modellen.seo.title : 'Modellen | Meiden van Holland' },
                { hid: 'description', name: 'description', content: this.pages.modellen && this.pages.modellen.seo ? this.pages.modellen.seo.description : 'Geile Hollandse amateur meiden en pornosterren spelen in de lekkerste sexfilms. Kim Holland en haar vriendinnen neuken voor jou in de lekkerste standjes.'},
                { hid: 'og:description', name: 'og:description', content: this.pages.modellen && this.pages.modellen.seo ? this.pages.modellen.seo.description : 'Geile Hollandse amateur meiden en pornosterren spelen in de lekkerste sexfilms. Kim Holland en haar vriendinnen neuken voor jou in de lekkerste standjes.' },
                { hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/modellen' },
                { hid: 'keywords', name: 'keywords', content: this.pages.modellen && this.pages.modellen.seo ? this.pages.modellen.seo.keywords : 'geile meiden, sex actrices, pornosterren, Hollandse meiden'},
            ]
        }
    },
    name: 'modelsCollection',
    components: {
        dummyCollection: () => import('~/components/content/dummy/collection.vue'),
        filters: () => import('~/components/filters/filtermodule.vue'),
        modelItem: () => import('~/components/content/model/model.vue'),
        banner: () => import('~/components/banner.vue'),
        about: () => import('~/components/about_section.vue'),
    },
    computed: {
        ...mapState({
            queries: ({ resourcesStore: {queries} }) => queries,
            models: ({ resourcesStore: {models} }) => models,
            loading: ({ resourcesStore: { loading } }) => loading,
            pages: ({ pagesStore: {pages} }) => pages
        }),
    },
}
